import dayjs from 'dayjs';
import { capitalize } from 'lodash-es';

import { VFlex } from '../VFlex';
import { DeployedCode, File, Folder, Image } from '../asset';
import type { Column } from './type';
import { getExt, isImage, isPcd } from './util';

export const DEFAULT_COLUMN_LIST: Column<{}>[] = [
  { name: 'name', render: capitalize },
  { name: 'eTag', render: capitalize, hidden: true },
  { name: 'size', render: capitalize },
  { name: 'createdAt', render: capitalize, hidden: true },
  { name: 'updatedAt', render: capitalize },
];

export const DEFAULT_EMPTY_LIST_TEXT = {
  TREE: 'No folders have been uploaded yet.',
  CONTENT_LIST:
    'No files have been uploaded yet.\nDrag and drop your files here to get started with VueX!',
};

export const ExtIcon = {
  Image: () => <Image className="h-5 w-5 min-w-5 text-[#967CFF]" />,
  Pcd: () => <DeployedCode className="h-5 w-5 min-w-5 text-[#6CCBA5]" />,
  File: () => <File className="h-5 w-5 min-w-5 text-[#ECBA64]" />,
  Folder: () => <Folder className="h-5 w-5 min-w-5 text-[#50C7FF]" />,
};

export const DEFAULT_RENDER_CELL = {
  name: (value: string, isDir?: boolean) => {
    const token = value.replace(/\/$/, '').split('/');
    const name = token[token.length - 1];
    const ext = getExt(name);

    return (
      <VFlex className="h-full" items="center" gap={0.5}>
        {!ext || isDir ? (
          <ExtIcon.Folder />
        ) : isImage(ext) ? (
          <ExtIcon.Image />
        ) : isPcd(ext) ? (
          <ExtIcon.Pcd />
        ) : (
          <ExtIcon.File />
        )}
        <div className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
          {name}
        </div>
      </VFlex>
    );
  },
  size: (value: number) => (
    <VFlex items="center" className="h-full">
      {((value as number) / 2 ** 20).toFixed(2)} MB
    </VFlex>
  ),
  lastModified: (value: DateLike | null) => (
    <VFlex items="center" className="h-full">
      <span className="text-body-m">
        {value != null ? dayjs(value).format('YYYY-MM-DD hh:mm:ss') : ''}
      </span>
    </VFlex>
  ),
} as const;
